import React, { useMemo } from "react";
import { StyleProp, StyleSheet, TextStyle } from "react-native";
import { useTheme } from "../hooks/use-theme";
import Text from "./Text";

type InfoTextProps = {
    text: string;
    style?: StyleProp<TextStyle>;
};

const InfoText: React.FC<InfoTextProps> = ({ text, style }) => {
    const styles = useStyles();
    return <Text style={[styles.text, style]}>{text}</Text>;
};

const useStyles = () => {
    const { colors, fonts } = useTheme();
    return useMemo(
        () =>
            StyleSheet.create({
                text: {
                    ...fonts.bodySmall,
                    color: colors.onSurfaceDisabled,
                    textAlign: "center",
                },
            }),
        [colors.onSurfaceDisabled, fonts.bodySmall],
    );
};

export default InfoText;
